import React from 'react';
import {
  ContextualMenu,
  IContextualMenuItem,
  IContextualMenuStyles,
  Target,
} from '@fluentui/react';

interface IProps {
  items: IContextualMenuItem[];
  menuTarget: Target;
  onClose: () => void;
}

const styles: Partial<IContextualMenuStyles> = {
  root: {
    minWidth: '100px',
  },
};

export default ({ items, menuTarget, onClose }: IProps) => {
  return (
    <ContextualMenu
      items={items}
      target={menuTarget}
      onItemClick={onClose}
      onDismiss={onClose}
      styles={styles}
      isBeakVisible={false}
    />
  );
};
